<template>
    <!-- Teleport renders this content into the <body> tag -->
    <Teleport to="body">
      <div v-if="modelValue" class="modal-overlay" @click.self="close">
        <div class="modal-content">
          <div class="close" @click="close"><i class="material-icons">close</i></div>
          <!-- Slot for modal content -->
          <slot></slot>
        </div>
      </div>
    </Teleport>
  </template>
  
  <script setup>
    
  const props = defineProps({
    // Prend le v-model qui est binded dans le parent
    modelValue: {
      type: Boolean,
      default: false,
    },
  })
  const emits = defineEmits(['update:modelValue'])
  
  // Close the modal by emitting a change to false
  function close() {
    emits('update:modelValue', false)
  }
  </script>
  
  <style scoped lang="scss">

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999; /* Ensure it sits on top */
  }
  
  .modal-content {
    background: #fff;
    padding: 1rem 3rem 1rem 3rem;
    border-radius: 4px;
    min-width: 300px;
    max-width: 90%;
    overflow-y: auto;
    max-height: 90vh;
    position: relative;
  }

  .close{
    position: absolute;

        top: 0;
        right: 0;

        margin: 10px;
        padding: 0;

        background-color: transparent;
        border: none;

        justify-content: center;
        align-items: center;
        align-self: center;

    cursor: pointer;

    i {
      font-size: 40px;
    }

    &:hover{
      color: $orange;
    }
  }

  </style>
  